module.exports = __webpack_public_path__ + "static/media/lightsup.ce9603eb.png";